/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.DynamicPortalRpc
 */
import * as References from './DynamicPortalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.DynamicPortalRpc#getDynamicPortalObjects
 */
export const GET_DYNAMIC_PORTAL_OBJECTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_DynamicPortalRpc_getDynamicPortalObjects';
export const GET_DYNAMIC_PORTAL_OBJECTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DYNAMIC_PORTAL_OBJECTS_QUERY_FIELD_NAME,
  args: ['limit', 'pageCursor', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDynamicPortalObjectsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.DynamicPortalRpc#getCrmObjectContacts
 */
export const GET_CRM_OBJECT_CONTACTS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_DynamicPortalRpc_getCrmObjectContacts';
export const GET_CRM_OBJECT_CONTACTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CRM_OBJECT_CONTACTS_QUERY_FIELD_NAME,
  args: ['offset', 'limit', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getCrmObjectContactsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});